import { DashboardOutlined, DescriptionOutlined, PeopleOutlined, EmailOutlined } from "@mui/icons-material";

export const HEADER_NAVIGATION_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: <DashboardOutlined />,
    end: true,
  },
  {
    id: "interviews",
    label: "Positions",
    path: "/interviews",
    icon: <DescriptionOutlined />,
  },
  {
    id: "candidates",
    label: "Candidates",
    path: "/candidates",
    icon: <PeopleOutlined />,
  },
  {
    id: "email-activity",
    label: "Email Activity",
    path: "/email-activity",
    icon: <EmailOutlined />,
  },
  // {
  //   id: "users",
  //   label: "User Management",
  //   path: "/user-management",
  //   icon: <PeopleOutlined />,
  // },
];
